import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=dc09dd06&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=dc09dd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc09dd06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc09dd06')) {
      api.createRecord('dc09dd06', component.options)
    } else {
      api.reload('dc09dd06', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=dc09dd06&scoped=true&", function () {
      api.rerender('dc09dd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-209pZ5VOBQdYH/JS/comp/GuestBox.vue"
export default component.exports